import { useEffect, useRef } from 'react'

export const useBodyScrollLock = (isLocked: boolean) => {
  const timeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (isLocked) {
      document.documentElement.style.overflow = 'hidden'
      document.documentElement.style.height = '100%'
    } else {
      timeoutRef.current = setTimeout(() => {
        document.documentElement.style.overflow = ''
        document.documentElement.style.height = ''
        document.body.style.width = ''
        document.body.style.overflow = ''
      }, 250)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [isLocked])
}
